import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const menuItemStyles = (theme, fieldVariant) => {
  // Note: these styles were taken from useEditableDataRowClasses

  const justifyContent = {
    [FieldVariant.dataRow]: 'flex-end',
    [FieldVariant.form]: 'flex-start',
  };

  return {
    root: {
      '&.MuiButtonBase-root': {
        justifyContent: justifyContent[fieldVariant],
        fontSize: theme.typography.subtitle2.fontSize,
        color: 'inherit',
      },
    },
  };
};
